const DEFAULT_THEMING_COLOR = '#34b196';

const PROPERTIES_MAP = {
  themeColor: 'theme-color'
};

const DEFAULT_PROPERTIES = {
  themeColor: DEFAULT_THEMING_COLOR
};

export function createThemeMetas(props = {}) {
  const mergedProps = { ...DEFAULT_PROPERTIES, ...props };
  const allowedKeys = Object.keys(PROPERTIES_MAP);

  return allowedKeys
    .filter(key => typeof mergedProps[key] !== 'undefined')
    .reduce(
      (acc, key) => [
        ...acc,
        {
          name: PROPERTIES_MAP[key],
          content: mergedProps[key]
        }
      ],
      []
    );
}

export default {
  createThemeMetas,
  DEFAULT_THEMING_COLOR
};
